import api from "APP_ROOT/api";
import {
  ADMIN,
  REPAIR,
  SALES,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";

export function searchSellers(filter) {
  return () =>
    api.users
      .search({
        active: true,
        filter,
        page: 1,
        limit: 6,
        roles: [ADMIN, SALES, REPAIR],
        subroles: [WAREHOUSE_LOGISTICS_DIRECTOR],
        permissions: [SALES]
      })
      .then(resp => Promise.resolve(resp.data.results));
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/FormSections/SellersSection/actions.js